import { Card } from '../components/Card'
import { useSearchParams } from 'react-router-dom';
import { useFetch } from '../hooks/useFetch';

export const Search = ({api}) => {

  const [searchParams]=useSearchParams();
  const query=searchParams.get("q");
  
  const {data:movies}=useFetch(api,query);

  return (
    <main>
      <section>
        <p className='text-3xl  py-7 text-fray-700 dark:text-white'>
          {movies.length===0?`No result Found for ${query}`:`Results for ${query}`}
        </p>
      </section>
      <section className='max-w-7xl mx-auto py-7'>
        <div className='flex justify-start flex-wrap'>
          { movies.map((movie)=>(
            <Card key={movie.id} movie={movie}/>
          ))
          }
        </div>
      </section>
    </main>
  )
}